import { useToast } from '@repo/design-system/index'
import { useRouter } from 'next/router'
import CopyToClipboard from 'react-copy-to-clipboard'
import { TwitterShareButton } from 'react-share'
import { IS_DEVELOPMENT, RINGLE_DOMAIN } from '../../../../modules/envVars'
import LinkLocale from '../../../../modules/i18n/LinkLocale'
import { OFFICE_EVENT_TWITTER, WINTER_REFERRAL_FACEBOOK } from '../../../../modules/images'
import { REFERRAL_ICON_COPY_LINK, REFERRAL_ICON_SHARE_LINKEDIN } from '../../../../modules/svg/svg'
import urls from '../../../../modules/urls'

const ComponentFromSocialMediumProps = ({ componentName, url, title, isMobile }) => {
  const SocialMediumProps = {
    Twitter: {
      Parent: TwitterShareButton,
      Child: OFFICE_EVENT_TWITTER,
      componentSpecificProps: {
        title: title,
      },
    },
  }

  const SocialMedium = SocialMediumProps[componentName]

  if (!SocialMedium) {
    return null
  }

  const Parent = SocialMedium.Parent
  const Child = SocialMedium.Child
  const componentSpecificProps = SocialMedium.componentSpecificProps

  return (
    <div className="flex items-center justify-center">
      <Parent {...componentSpecificProps} url={url}>
        <img src={Child} className={isMobile ? 'w-[36px]' : 'w-[47px]'} alt="sns" />
      </Parent>
    </div>
  )
}

const BlogDetailTagsSharingSection = ({ tagList, title, subtitle, isMobile, imgUrl }) => {
  const toast = useToast()
  const { query } = useRouter()
  const socialMediaArray = [{ compName: 'Twitter' }]
  const url = `https://${IS_DEVELOPMENT ? 'qa7.ringlefront.com' : RINGLE_DOMAIN}/ko/student/landing/blog/${query.slug}`

  return (
    <div className={style(isMobile).tagsAndSharingSectionLayout}>
      <div className={style(isMobile).tagsAndSharingSectionTagsLayout}>
        {tagList.map((tag, i) => (
          <LinkLocale key={i} href={urls.student.landing.blog.tags(tag)}>
            <div className={style(isMobile).tagsAndSharingSectionTag}>{tag}</div>
          </LinkLocale>
        ))}
      </div>
      <hr className="my-[16px]" />
      <div className={style(isMobile).tagsAndSharingSectionSharingLayout}>
        {/* COPY LINK */}
        <CopyToClipboard text={url} onCopy={() => toast.toastInfo('URL이 복사되었습니다.')}>
          <img
            src={REFERRAL_ICON_COPY_LINK}
            alt="copy"
            className={isMobile ? 'h-[36px] w-[36px] cursor-pointer' : 'h-[48px] w-[48px] cursor-pointer'}
          />
        </CopyToClipboard>
        {/* LINKEDIN */}
        <a
          className="ml-0"
          href={`https://www.linkedin.com/shareArticle?mini=true&url=${url}`}
          target="_blank"
          rel="noreferrer"
        >
          <img
            src={REFERRAL_ICON_SHARE_LINKEDIN}
            alt="copy"
            className={isMobile ? 'h-[36px] w-[36px] cursor-pointer' : 'h-[48px] w-[48px] cursor-pointer'}
          />
        </a>
        {/* TWITTER */}
        <div>
          {socialMediaArray.map((componentName, index) => {
            return (
              <div key={index}>
                <ComponentFromSocialMediumProps
                  componentName={componentName.compName}
                  url={url}
                  title={title}
                  isMobile={isMobile}
                />
              </div>
            )
          })}
        </div>
        {/* FACEBOOK */}
        <div
          onClick={() =>
            window.open(
              'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url),
              '공유하기',
              'width=600,height=400'
            )
          }
        >
          <img
            src={WINTER_REFERRAL_FACEBOOK}
            alt="facebook"
            className={isMobile ? 'h-[36px] w-[36px] cursor-pointer' : 'h-[47px] w-[47px] cursor-pointer'}
          />
        </div>
      </div>
    </div>
  )
}

export default BlogDetailTagsSharingSection

const style = (isMobile) =>
  isMobile
    ? {
        tagsAndSharingSectionLayout: `mt-[120px] px-[16px]`,
        tagsAndSharingSectionTagsLayout: `flex flex-row gap-[8px] `,
        tagsAndSharingSectionTag: `Body2-14Bd rounded-[4px] bg-gray-100 py-[4px] px-[10px] text-gray-600`,
        tagsAndSharingSectionSharingLayout: `mb-[80px] flex flex-row justify-end gap-[8px]`,
      }
    : {
        tagsAndSharingSectionLayout: `mt-[120px]`,
        tagsAndSharingSectionTagsLayout: `flex flex-row gap-[8px]`,
        tagsAndSharingSectionTag: `Body2-14Bd rounded-[4px] bg-gray-100 py-[4px] px-[10px] text-gray-600`,
        tagsAndSharingSectionSharingLayout: `mb-[80px] flex flex-row justify-end gap-[8px]`,
      }
